import { render, staticRenderFns } from "./crud.vue?vue&type=template&id=ea88a2ba&scoped=true&"
import script from "./crud.vue?vue&type=script&lang=js&"
export * from "./crud.vue?vue&type=script&lang=js&"
import style0 from "./crud.vue?vue&type=style&index=0&id=ea88a2ba&prod&lang=css&"
import style1 from "./crud.vue?vue&type=style&index=1&id=ea88a2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea88a2ba",
  null
  
)

export default component.exports